import React from "react";
import Loading from "../../Components/Loading";
import { useSinglePeyments } from "./Hooks";

const Single = () => {
  const { loading, data } = useSinglePeyments();
  const renderModel = (model) => {
    switch (model) {
      case "Plan":
        return "خرید اشتراک";
      case "Ads":
        return "ثبت آگهی";
      case "AdsOption":
        return "خرید امکانات آگهی";
      default:
        return "-"
    }
    return {};
  };
  const renderDetails = (model) => {
    switch (model) {
      case "Plan":
        return (
          <>
            <div className="col-12 box">
              <div>
                <span>نام اشتراک : </span>
              </div>
              <div>
                <span>{data?.plan?.title || "ثبت نشده"}</span>
              </div>
            </div>
            <div className="col-12 box">
              <div>
                <span>مدت اشتراک : </span>
              </div>
              <div>
                <span>{data?.plan?.period || "ثبت نشده"} روزه</span>
              </div>
            </div>
            <div className="col-12 mt-2">
              <div>
                <span>توضیحات اشتراک: </span>
              </div>
              <div>
                <span>{data?.plan?.description || "ثبت نشده"}</span>
              </div>
            </div>
          </>
        );
      case "Ads":
        return (
          <>
            <div className="col-12 box">
              <div>
                <span>عنوان اگهی : </span>
              </div>
              <div>
                <span>{data?.ads?.title || "ثبت نشده"}</span>
              </div>
            </div>
            <div className="col-12 mt-2 box">
              <div>
                <span>هزینه ثبت اگهی : </span>
              </div>
              <div>
                <span>{data?.category_price || "ثبت نشده"}</span>
              </div>
            </div>
            <div className="col-12 mt-2 =">
              <div>
                <span>امکانات : </span>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">عنوان</th>
                    <th scope="col">هزینه</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.option?.map((op, key) => {
                    return (
                      <tr>
                        <th scope="row">{key + 1}</th>
                        <td>{op.title}</td>
                        <td>{op.price}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        );
      case "AdsOption":
        return (
          <>
            <div className="col-12 box">
              <div>
                <span>عنوان اگهی : </span>
              </div>
              
              <div>
                <span>{data?.ads?.title || "ثبت نشده"}</span>
              </div>
            </div>
            <div className="col-12 mt-2 box">
              <div>
                <span>هزینه ثبت اگهی : </span>
              </div>
              <div>
                <span>{data?.category_price || "ثبت نشده"}</span>
              </div>
            </div>
            <div className="col-12 mt-2 =">
              <div>
                <span>امکانات : </span>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">عنوان</th>
                    <th scope="col">هزینه</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.option?.map((op, key) => {
                    return (
                      <tr>
                        <th scope="row">{key + 1}</th>
                        <td>{op.title}</td>
                        <td>{op.price}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        );
      default: return ('-')
    }
    return {};
  };
  if (loading) {
    return (
      <div className="row">
        <Loading count={2} col={12} height={"350px"} />
      </div>
    );
  }
  return (
    <div className="row justify-content-center">
      <div className="col-8">
        <div className="row card peyment-single">
          <div className="col-12">
            {data?.status == "error" ? (
              <div className="header-box-error">
                <h3>خطا در تراکنش</h3>
                <span>{data?.bankmessage}</span>
              </div>
            ) : (
              <div className="header-box-success">
                <h3>تراکنش موفق</h3>
              </div>
            )}
          </div>
          <div className="col-12 mt-4">
            <div className="title">مشخصات پرداخت</div>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-12 box">
                    <div>
                      <span>کد تراکنش : </span>
                    </div>
                    <div>
                      <span>{data?.transid || "ثبت نشده"}</span>
                    </div>
                  </div>
                  <div className="col-12 box">
                    <div>
                      <span>کد ارجاع : </span>
                    </div>
                    <div>
                      <span>{data?.ref_id || "ثبت نشده"}</span>
                    </div>
                  </div>
                  <div className="col-12 box">
                    <div>
                      <span>کد پیگیری تراکنش : </span>
                    </div>
                    <div>
                      <span>{data?.trackingcode || "ثبت نشده"}</span>
                    </div>
                  </div>
                  <div className="col-12 box">
                    <div>
                      <span>کد پیگیری درون سامانه ای : </span>
                    </div>
                    <div>
                      <span>{data?.local_trackingcode || "ثبت نشده"}</span>
                    </div>
                  </div>
                  <div className="col-12 box">
                    <div>
                      <span>نوع پرداخت: </span>
                    </div>
                    <div>
                      <span>
                        {renderModel(data?.model_order) || "ثبت نشده"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-12 box">
                    <div>
                      <span>کد تخفیف : </span>
                    </div>
                    <div>
                      <span>{data?.discount == 0 ? "ندارد" : "دارد"}</span>
                    </div>
                  </div>
                  <div className="col-12 box">
                    <div>
                      <span>مجموع مبلغ : </span>
                    </div>
                    <div>
                      <span>{data?.growth_price}</span>
                    </div>
                  </div>
                  <div className="col-12 box">
                    <div>
                      <span>میزان تخفیف : </span>
                    </div>
                    <div>
                      <span>{data?.discount}</span>
                    </div>
                  </div>
                  <div className="col-12 box">
                    <div>
                      <span>مبلغ پرداختی : </span>
                    </div>
                    <div>
                      <span>{data?.total_price}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 mt-4">
            <div className="title">مشخصات خرید</div>
            <div className="row mt-3">{renderDetails(data?.model_order)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Single;
